import { useCallback, useEffect, useState } from 'react';
import { fetchBuhServiceStatus } from '../api/buhServiceApi';
import { socket } from '../components/chat/useSocket';

export function useBuhServiceSuspended(userId, companyId) {
    const [suspended, setSuspended] = useState(false);

    const load = useCallback(async () => {
        if (!userId && !companyId) {
            setSuspended(false);
            return;
        }
        try {
            const status = await fetchBuhServiceStatus(userId, companyId);
            setSuspended(!!status?.service_suspended);
        } catch (error) {
            console.error('useBuhServiceSuspended', error);
            setSuspended(false);
        }
    }, [userId, companyId]);

    useEffect(() => {
        if (!userId && !companyId) {
            setSuspended(false);
            return undefined;
        }

        const onStatusChanged = (payload) => {
            if (companyId) {
                load();
                return;
            }
            if (Number(payload?.user_id) !== Number(userId)) return;
            setSuspended(!!payload?.service_suspended);
        };

        const onNewPack = (payload) => {
            if (companyId) {
                load();
                return;
            }
            if (Number(payload?.user_id) !== Number(userId)) return;
            load();
        };

        load();
        socket.on('buhServiceStatusChanged', onStatusChanged);
        socket.on('newPack', onNewPack);

        return () => {
            socket.off('buhServiceStatusChanged', onStatusChanged);
            socket.off('newPack', onNewPack);
        };
    }, [userId, companyId, load]);

    return suspended;
}
